import styled from "styled-components";

const brandGradient = "linear-gradient(90deg, #D2D1FF 0%, #FFE1A2 100%)";

export const Tabs = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
`;

export const Tab = styled.button`
  font-family: Raleway;
  font-size: 16px;
  font-weight: 700;
  padding: 10px 20px;
  border-radius: 12px;
  cursor: pointer;
  background: ${(props) => (props.$active ? brandGradient : "#F3F2FA")};
  color: #3D3D3D;
`;

export const Filters = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
`;

export const Filter = styled.button`
  font-family: Raleway;
  font-size: 14px;
  padding: 6px 14px;
  border-radius: 999px;
  cursor: pointer;
  border: 1px solid ${(props) => (props.$active ? "#A9A4F0" : "#E2E0EE")};
  background: ${(props) => (props.$active ? "#EFEDFF" : "#FFFFFF")};
`;

export const Error = styled.p`
  font-family: Raleway;
  font-size: 14px;
  color: #B02C41;
  background: #FDE8EB;
  padding: 10px 14px;
  border-radius: 10px;
  margin-bottom: 16px;
`;

export const Empty = styled.p`
  font-family: Raleway;
  color: #6B6B6B;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 960px;
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 16px 18px;
  border-radius: 14px;
  background: #FFFFFF;
  border: 1px solid #ECEAF6;
`;

export const RowMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const RowTitle = styled.p`
  font-family: Raleway;
  font-size: 16px;
  font-weight: 700;
`;

export const RowMeta = styled.p`
  font-family: Raleway;
  font-size: 13px;
  color: #6B6B6B;
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;

const STATUS_COLORS = {
  new: ["#FFF4D6", "#8A6A00"],
  done: ["#E2F6EC", "#107A50"],
  cancelled: ["#F1F1F1", "#6B6B6B"],
};

export const StatusBadge = styled.span`
  font-family: Raleway;
  font-size: 13px;
  font-weight: 600;
  padding: 5px 12px;
  border-radius: 999px;
  background: ${(props) => STATUS_COLORS[props.$status]?.[0]};
  color: ${(props) => STATUS_COLORS[props.$status]?.[1]};
`;

export const Button = styled.button`
  font-family: Raleway;
  font-size: 14px;
  font-weight: 700;
  padding: 8px 16px;
  border-radius: 10px;
  cursor: pointer;
  background: ${brandGradient};
  color: #000000;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const GhostButton = styled.button`
  font-family: Raleway;
  font-size: 14px;
  padding: 8px 14px;
  border-radius: 10px;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid #D9D6EA;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const ItemCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 18px;
  border-radius: 14px;
  background: #FFFFFF;
  border: 1px solid #ECEAF6;
  opacity: ${(props) => (props.$inactive ? 0.6 : 1)};
`;

export const ItemHeader = styled.p`
  font-family: Raleway;
  font-size: 16px;
  font-weight: 700;
`;

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 160px;
  font-family: Raleway;
  font-size: 13px;
  color: #6B6B6B;
`;

export const FieldRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-end;
`;

export const Input = styled.input`
  font-family: Raleway;
  font-size: 15px;
  color: #3D3D3D;
  padding: 9px 12px;
  border-radius: 10px;
  border: 1px solid #D9D6EA;
`;

export const TextArea = styled.textarea`
  font-family: Raleway;
  font-size: 15px;
  color: #3D3D3D;
  padding: 9px 12px;
  border-radius: 10px;
  border: 1px solid #D9D6EA;
  resize: vertical;
`;

export const Select = styled.select`
  font-family: Raleway;
  font-size: 15px;
  padding: 9px 12px;
  border-radius: 10px;
  border: 1px solid #D9D6EA;
  background: #FFFFFF;
`;

export const Checkbox = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: Raleway;
  font-size: 14px;
  padding-bottom: 10px;
  cursor: pointer;
`;
